module.exports = __webpack_public_path__ + "static/media/gu.2a95d57a.svg";